import { DiscountType } from '../../../types/Promo';

export const useCalculateDiscountHook = (
    price?: number,
    type?: DiscountType,
    discountAmount?: number
) => {
    if (price === undefined || type === undefined || discountAmount === undefined) return '0';

    switch (type) {
        case DiscountType.FlatAmount:
            return discountAmount.toFixed(2);
        case DiscountType.Percent:
            return ((discountAmount / 100) * price).toFixed(2);
    }
};
